import React from 'react'
import { useBenefits } from '../BenefitsProvider'
import { useTranslation } from '~/hooks/useTranslation'
import ScheduleDialog from '../ProfessionalServices/ScheduleDialog'
import MeetingInfo from '../ProfessionalServices/MeetingInfo'
import { RevisionFeedback } from './Step'
import CloseReviewDialog from './CloseReviewDialog'
import MessageCoachDialog from './MessageCoachDialog'
import { Button } from '~/components/_atoms/index'

const ResumeRevisions = () => {
  const {
    resumeRevisions,
    resumeReview,
    onScheduleClick,
    current_user,
    coach,
    setShowCloseReviewDialog,
    setShowMessageCoachDialog,
    showMessageCoachDialog,
    programLevel,
  } = useBenefits()
  const { t } = useTranslation()

  const calendlyEvent =
    resumeRevisions[resumeRevisions?.length - 1].calendly_event

  const calendlyEventExists =
    resumeRevisions[resumeRevisions?.length - 1].calendly_event != undefined

  const noShow =
    calendlyEventExists && calendlyEvent?.service_request_no_show_id

  const meetingViaCalendly =
    resumeRevisions[resumeRevisions?.length - 1].meeting_via_calendly

  const revisionScheduled =
    resumeReview.status === 'revision_meeting_requested' && calendlyEventExists

  const revisionReturned =
    resumeReview.status === 'revision_returned' ||
    resumeReview.status === 'final_revision_returned' ||
    (resumeReview.status === 'closed' && resumeRevisions.length > 2)

  const scheduleRevisionMeeting =
    (resumeReview.status !== 'closed' &&
      (resumeReview.status === 'returned' ||
        (resumeReview.status == 'revision_meeting_requested' &&
          meetingViaCalendly &&
          !calendlyEventExists))) ||
    (resumeReview.status === 'revision_requested' &&
      meetingViaCalendly &&
      !calendlyEventExists)

  const coachRevisionCount = resumeRevisions.filter(
    (revision) => revision.type === 'ResumeRevision::CoachRevision',
  ).length

  const handleSubmitRevisionRequest = () => {
    onScheduleClick(
      'ResumeRevision::CandidateRevision',
      t(`${programLevel}.steps.askForRevisions.submit_revision_request`),
      true,
      1,
      coachRevisionCount,
    )
  }

  const buttonText = noShow
    ? t(`${programLevel}.steps.scheduleMeeting.reschedule_meeting`)
    : t(`${programLevel}.steps.scheduleMeeting.schedule_a_meeting`)

  if (!resumeReview || !resumeRevisions) return null
  return (
    <>
      {revisionReturned && (
        <RevisionFeedback
          revision={resumeRevisions[2]}
          stepKey="askForRevisions"
        />
      )}
      {revisionScheduled && (
        <div className="mt-4">
          <MeetingInfo
            calendlyEvent={
              resumeRevisions[resumeRevisions?.length - 1].calendly_event
            }
            requestType="ServiceRequest::ResumeReview"
            buttonText={buttonText}
            requestComplete={resumeReview.status == 'returned'}
            eventName="Meeting"
            cardTitle={t(
              `${programLevel}.steps.scheduleMeeting.schedule_your_coach_meeting`,
            )}
            flexResumeReview={true}
            meetingViaCalendly={true}
          />
        </div>
      )}
      {scheduleRevisionMeeting && (
        <div className="mt-4 space-y-6">
          <div className="flex gap-4">
            <Button color="secondary" onClick={handleSubmitRevisionRequest}>
              {t(
                `${programLevel}.steps.askForRevisions.submit_revision_request`,
              )}
            </Button>
            <Button
              variant="outline"
              color="secondary"
              onClick={() => {
                setShowCloseReviewDialog(true)
              }}
            >
              {t('close_review')}
            </Button>
            <ScheduleDialog
              current_user={current_user}
              coach={coach}
              flexResumeReview={true}
            />
            <Button
              variant="outline"
              color="secondary"
              onClick={() => setShowMessageCoachDialog(true)}
            >
              {t('message_coach')}
            </Button>
            <CloseReviewDialog />
            <MessageCoachDialog
              isOpen={showMessageCoachDialog}
              onClose={() => setShowMessageCoachDialog(false)}
            />
          </div>
        </div>
      )}
    </>
  )
}

export default ResumeRevisions
